<template>
  <div class="smart-components-wrapper">
    <!-- _.get($store.state.main.selected_menu, -->

    <template v-for="(component, componentKey) in loopComponents">
      <transition name="fade" :key="component.selectedComponent + componentKey">
        <component
          v-if="getContentData(component)"
          :is="component.selectedComponent"
          :key="component.selectedComponent + componentKey"
          :contentData="getContentData(component)"
          :evenOdd="componentKey % 2"
        />
      </transition>
    </template>
  </div>
</template>

<script>

export default {
  name: "smartComponentsLoader",
  data() {
    return {};
  },
  created() {
        this.$store.commit("main/setCurrentMenuLocalePaths", this.$route.params);
    let components = _.get(this.$store.state.main.indx, "smartComponents");

    for (let i in components) {
      this.$options.components[i] = () =>
        import("../../components/smartComponents/" + i);
    }
  },
  mounted() {},
  watch: {},
  computed: {
    loopComponents() {
      let smartComponents = _.get(
        this.$store.state.main.selected_menu,
        "secondary_data"
      );
      let singleOrList = _.get(
        this.$store.state.main.selected_menu,
        "routeParams.singleview"
      )
        ? "single"
        : "list";

      let ret = [];
      for (let i in smartComponents) {
        if (_.get(smartComponents[i], "enabled") != 1) continue;

        //// exclude component depend on menu settings
        if (
          singleOrList === "list" &&
          _.get(smartComponents[i], "listLayout") != 1
        ) {
          continue;
        } else if (
          singleOrList === "single" &&
          _.get(smartComponents[i], "singleLayout") != 1
        ) {
          continue;
        }

        // console.log(i, smartComponents[i].selectedComponent, singleOrList, 'primary: '+_.get( smartComponents[i], 'primary'), smartComponents[i]);
        ret.push(smartComponents[i]);
      }
      // console.log(ret);
      return ret;
    }
  },
  methods: {
    getContentData(component) {
      // console.log(component);

      let selectedComponent = _.get(component, "selectedComponent");
      let componentUnicId = _.get(component, "unicId");
      let primary = _.get(component, "primary");

      // console.log(selectedComponent, componentUnicId, primary, _.get( this.$store.state.main.current_content, ['secondary'] ));

      if (
        primary &&
        _.get(this.$store.state.main.current_content, ["primary"])
      ) {
        // console.log(component);
        return _.get(this.$store.state.main.current_content, ["primary"]);
      }

      return _.get(this.$store.state.main.current_content, [
        "secondary",
        selectedComponent + "_" + componentUnicId
      ]);
    }
  }
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  // transition-duration: 1.4s;
  // transition-property: opacity;
  // transition-timing-function: ease;
  // opacity: 1;
  @media (max-width: 767px){
    // transition-duration: 2.5s;
  }
}
.fade-enter-active {
  // transition-delay: 0s;
}

.fade-enter,
.fade-leave-active {
  // opacity: 0;
}
</style>
